import { render, staticRenderFns } from "./_statements.vue?vue&type=template&id=c6336e04"
import script from "./_statements.vue?vue&type=script&lang=js"
export * from "./_statements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports